export { SimpleProductCard } from './SimpleProductCard';
